__turbopack_context__.v({
  "footnote-back-reference": "styles-module__f0hnGa__footnote-back-reference",
  "footnote-forward-reference": "styles-module__f0hnGa__footnote-forward-reference",
});
